import * as React from "react"
import { Checklist, ChecklistItem } from "@/components/Checklist"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"

const FeaturesWithCallToAction = ({ title, cta, showCta = true }) => {
  const { t } = useTranslation()

  return (
    <section className="mb-14">
      <div className="container-fluid">
        <div className="row center-xs col-xs-12 mb-10">
          <h2 className="col-md-7 start-xs center-sm">{title}</h2>
          <Checklist className="checklist--dark row gap-6 center-sm mt-0 pt-0">
            <ChecklistItem className="pl-7 start-sm ml-4 mr-4 pr-0">
              {t("campaign.cta.features.sales-dashboard")}
            </ChecklistItem>

            <ChecklistItem className="pl-7 start-sm ml-4 mr-4 pr-0">
              {t("campaign.cta.features.calendar-and-tasks")}
            </ChecklistItem>

            <ChecklistItem className="pl-7 start-sm ml-4 mr-4 pr-0">
              {t("campaign.cta.features.integrations")}
            </ChecklistItem>

            <ChecklistItem className="pl-7 start-sm ml-4 mr-4 pr-0">
              {t("campaign.cta.features.2fa")}
            </ChecklistItem>
          </Checklist>
        </div>
      </div>

      {showCta && (
        <section className="container-fluid">
          <div className="feature-call-to-action__container">
            <div className="col-md-7">
              <h3 className="h4">
                <strong>{t("campaign.cta.modal.title")}</strong>
              </h3>

              <p className="p--lg">{t("campaign.cta.modal.text")}</p>
            </div>

            {/* Only show CTA if text exists */}
            {cta.buttonText && (
              <div className="col-md-5 end-md">
                <a
                  className="btn btn--lg feature-call-to-action__button btn--secondary btn--lg"
                  href={cta.buttonLink}
                  title={cta.buttonText}
                >
                  {cta.buttonText}
                </a>
              </div>
            )}
          </div>
        </section>
      )}
    </section>
  )
}

export default FeaturesWithCallToAction
